import { render, staticRenderFns } from "./FormatAlignJustifyIcon.vue?vue&type=template&id=2bbd5cee"
import script from "./FormatAlignJustifyIcon.vue?vue&type=script&lang=js"
export * from "./FormatAlignJustifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports